export default "__VITE_ASSET__BeItd6cP__"